import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Protegge tutte le rotte tranne 'auth': verifica presenza e validità
 * (scadenza) del token JWT. Se assente o scaduto, ripulisce lo stato
 * e reindirizza l'utente alla landing di autenticazione.
 */
export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  authService.clearToken();
  return router.createUrlTree(['/auth']);
};
